import { useLocation, useNavigate } from 'react-router-dom';
import { useOnboardingState } from '../../hooks/useOnboardingState.jsx';
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined';
import Logo from '@/Asset/images/logo-blaxk.webp';
import welcome from '@/Asset/images/welcome.webp';
import EastIcon from '@mui/icons-material/East';
import StepIndicator from '../StepIndicator/StepIndicator';
import './Welcome.css';

const Welcome = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const { state, updateState } = useOnboardingState();
	const isStudioAccount = state.selectedPlanType === 'studio' || state.userType === 'studio-owner';
	const totalSteps = isStudioAccount ? 6 : 4;
	const subtitle = isStudioAccount
		? 'Thank you for becoming a Studio Account Member —'
		: "Your account is now active. Let's get to work and train smarter.";
	const subtitle2 = isStudioAccount
		? 'We’re excited to support your instructors and help your students grow stronger, smarter, and more confident in their training.'
		: "Answer a few questions to get customised training recommendations.";
	const stepItems = Array.from({ length: totalSteps }, (_, index) => index + 1);

	const handleContinue = () => {
		updateState({ currentStep: 4 });
		navigate(`/onboarding/step-1?${new URLSearchParams(location.search).toString()}`);
	};

	const handleSkipQuestions = () => {
		updateState({ currentStep: isStudioAccount ? 10 : 8 });
		navigate('/');
	};

	return (
		<div className="onboarding-welcome">
			<div className="onboarding-welcome__grid-overlay" />
			<div className="onboarding-welcome__content">
				<header className="onboarding-welcome__header">
					<div className="onboarding-welcome__brand-row">
						<button
							type="button"
							className="onboarding-welcome__back-btn"
							onClick={() => navigate(`/onboarding/checkout${location.search || ''}`)}
						>
							<KeyboardBackspaceOutlinedIcon />
						</button>
						<img src={Logo} alt="The Godfrey Method On Demand" className="onboarding-welcome__logo" />
					</div>

					<div className="onboarding-welcome__steps" aria-label={`Onboarding steps ${totalSteps} total`}>
						{stepItems.map((stepNumber, index) => (
							<div key={stepNumber} className="onboarding-welcome__step-item">
								<div className="onboarding-welcome__step-dot">{stepNumber}</div>
								{index < stepItems.length - 1 ? <div className="onboarding-welcome__step-line" /> : null}
							</div>
						))}
					</div>
				</header>

				<main className="onboarding-welcome__main">
					<p className="onboarding-welcome__eyebrow">Welcome To</p>
					<h1 className="onboarding-welcome__title">Godfrey Method On-Demand</h1>
					<p className="onboarding-welcome__subtitle">{subtitle}</p>
					<p className="onboarding-welcome__subtitle">{subtitle2}</p>
					<div className="onboarding-welcome__visual-wrap">
						<img src={welcome} alt="Godfrey Method training preview" className="onboarding-welcome__visual" />
					</div>
				</main>

				<div className="onboarding-welcome__footer">
					<button type="button" onClick={handleContinue} className="onboarding-welcome__continue-btn">
						Continue <EastIcon />
					</button>
					<button type="button" onClick={handleSkipQuestions} className="onboarding-welcome__skip-btn">
						Skip Questions
					</button>
				</div>
			</div>
		</div>
	);
};

export default Welcome;
